module.exports = __webpack_public_path__ + "fonts/EMprint-Light.da28e8e3.ttf";